export const ImagePlaceholderMixin = (Base) =>
  class extends Base {
    selectImage(imagePlaceholderName) {
      const selector = `[data-printess-target-param="${CSS.escape(imagePlaceholderName)}"]`;
      const imagePlaceholderInput = this.element.querySelector(selector);
      const formGroup = imagePlaceholderInput.closest('.form-group');
      const selectButton = formGroup.querySelector('.select-btn');

      selectButton.click();
    }

    pushImagePlaceholder(event) {
      let placeholder = event.target;
      let params = event.params;

      this.pushImagePlaceholderValue(placeholder, params);
    }

    pushImagePlaceholderValue(placeholder, params) {
      let target = params.target;
      let value = placeholder.value;

      if (placeholder.dataset.processRange && params.rangeSelect) {
        let queueItem = {
          placeholder: placeholder,
          params: params
        }

        if (this.assignRangeQueue.filter(queuedItem => queuedItem.placeholder.id == queueItem.placeholder.id).length == 0) {
          this.assignRangeQueue[this.assignRangeQueue.length] = queueItem;
          this.processAssignRangeQueue();
        }
      } else if (params.placeholder) {
        let placeholder = params.placeholder;
        let url = this.populateUrlParams(params.url, placeholder, value);

        this.applyImagePlaceholderValue({
          valuePresent: !!value,
          target: target,
          url: url
        });
      }
    }

    processAssignRangeQueue() {
      if (this.pushImagePlaceholderRangeValueRunning) {
        return;
      }

      let nextItem = this.assignRangeQueue.pop();

      if (nextItem) {
        this.pushImagePlaceholderRangeValue(nextItem.placeholder, nextItem.params);
      } else {
        this.pushImagePlaceholderRangeValueRunning = false;
      }
    }

    pushImagePlaceholderRangeValue(placeholder, params) {
      this.pushImagePlaceholderRangeValueRunning = true;
      let target = params.target;
      let value = placeholder.value;

      fetch(
        placeholder.dataset.printessRangeAssignPath,
        {
          method: 'PATCH',
          headers: { 'Content-type': 'application/json; charset=UTF-8' },
          body: JSON.stringify({
            authenticity_token: this.element.querySelector('input[name="authenticity_token"]').value,
            value: value,
          }),
        }
      ).then((response) => response.json())
        .then((json) => {
          let file = json.files[0];

          if (!file) {
            this.applyImagePlaceholderValue({
              valuePresent: false,
              target: target
            });

            this.pushImagePlaceholderRangeValueRunning = false;
            this.processAssignRangeQueue();
            return
          }

          let placeholder = file.image_library_link_attributes.data;
          let url = this.populateUrlParams(params.url, placeholder, file.name);

          this.applyImagePlaceholderValue({
            valuePresent: true,
            target: target,
            url: url
          });

          this.pushImagePlaceholderRangeValueRunning = false;
          this.processAssignRangeQueue();
        });
    }

    applyImagePlaceholderValue({ valuePresent, target, url }) {
      const urlObj = new URL(url, window.location.origin);
      urlObj.searchParams.set('v', Date.now());
      url = urlObj.toString();

      this.setFormFieldValue(target, url);
    }

    populateUrlParams(url, placeholder, value) {
      return url
        .replaceAll("/:s/", `/${encodeURIComponent(placeholder.secret)}/`)
        .replaceAll("/:path", `/${encodeURIComponent(value)}`);
    }
  };
